import type ToastViewState from './schema/ToastViewState';
import { createStore } from 'satcheljs';

const toastViewState: ToastViewState = {
    isToastShown: false,
    timerId: null,
};

export const getToastViewState = createStore<ToastViewState>('toastViewState', toastViewState);

export default getToastViewState();
